import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatDialog, PageEvent } from '@angular/material';
import { SelecionarStatusOrcamentoModalComponent } from '../modals/selecionar-status-orcamento-modal/selecionar-status-orcamento-modal.component';
import { StatusDoPedido, PerfilDoUsuario, OrigemFiltroPedido } from '../models/enum';
import { FiltroPedido } from '../models/filtro-pedido';
import { Pedido } from '../models/pedido';
import { PedidoLista } from '../models/pedido-lista';
import { VendaEntrega } from '../models/venda-entrega';
import { FiltroPedidoComponent } from '../pedido/filtro-pedido/filtro-pedido.component';
import { PedidoAnexoComponent } from '../pedido/pedido-anexo/pedido-anexo.component';
import { CarregandoService } from '../services/carregando.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PedidoAnexoService } from '../services/pedido-anexo.service';
import { PedidoService } from '../services/pedido.service';
import { PremissasService } from '../services/premissas.service';
import { RelatorioService } from '../services/relatorio.service';
import { UtilitarioService } from '../services/utilitario.service';
import { VisualizadorPdfComponent } from '../visualizador-pdf/visualizador-pdf.component';
import { ClienteService } from '../services/cliente.service';
import { Cliente } from '../models/cliente';
import { Router } from '@angular/router';
import { UsuarioLogado } from '../models/usuario-logado';
import { PaginatorService } from '../services/paginator.service';

declare const $: any;

@Component({
  selector: 'app-repasse',
  templateUrl: './repasse.component.html',
  styleUrls: ['./repasse.component.scss']
})
export class RepasseComponent implements OnInit, OnDestroy {

  // variáveis
  pedidosFiltrados: PedidoLista[] = [];
  carregando = true;
  campoOrdenacao = 'idvenda';
  ordenarDesc = true;
  editavel = true;

  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [10, 30, 50];
  itensPorPagina = 10;

  StatusDoPedido = StatusDoPedido;
  PerfilDoUsuario = PerfilDoUsuario;

  perfil: PerfilDoUsuario;

  filtroPedido: FiltroPedido = {
    dtFim: undefined, dtInicio: undefined, funcionario: undefined, idCupom: '', nomeCliente: '', status: undefined, etapas: [],
    integrador: undefined, orcStatus: undefined, codErp: '', pesquisaPorTimes: false
  };

  integradorPodeAnexar = false;

  cliente: Cliente;
  integrador = false;
  pedido: Pedido;
  itens: any[] = [];
  enderecoDeEntrega: VendaEntrega = new VendaEntrega();
  verCustos = undefined;
  administrador;
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  modulosAtivos: Number[] = [];

  usuarioLogado: UsuarioLogado;

  verExcel = false;
  buscouTotalPag = false;

  constructor(private pedidoService: PedidoService, public utilitarioService: UtilitarioService, public dialog: MatDialog, public premissasService: PremissasService,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService, private globalService: GlobalService, private paginatorService: PaginatorService,
    private relatorioService: RelatorioService, private pedidoAnexoService: PedidoAnexoService, private clienteService: ClienteService, private router: Router,) {
  }

  async ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.usuarioLogado = await this.globalService.consultaUsuario();

    this.verExcel = this.usuarioLogado.verExcel;

    await this.buscarModulosAtivos();

    this.integrador = await this.globalService.integrador();

    if (this.integrador) {
      await this.buscarCliente(this.usuarioLogado.id);
      if (!this.possuiModulo(2) || !this.cliente.podeVerMenuRepasse) {
        this.router.navigate(['/']);
      }
    }

    this.administrador = await this.globalService.administrador();
    this.verCustos = this.usuarioLogado.verCustos;
    this.perfil = await this.globalService.perfil();

    if (localStorage.getItem('filtroRepasse') !== null) {
      this.filtroPedido = JSON.parse(localStorage.getItem('filtroRepasse'));
    } else {
      if (this.perfil === PerfilDoUsuario.Vendedor) {
        this.filtroPedido.funcionario = this.usuarioLogado.id;
      }
    }

    this.buscarPedidos();
    this.buscarTotaisPedidos();
  }

  possuiModulo(modulo: Number) {
    return this.modulosAtivos.some(p => p === modulo);
  }

  async buscarModulosAtivos() {
    try {
      this.carregandoService.mostra('buscarModulosAtivos');

      this.modulosAtivos = await this.premissasService.consultarModulosAtivos().toPromise();

      this.carregandoService.esconde('buscarModulosAtivos');
    } catch (erro) {
      this.carregandoService.esconde('buscarModulosAtivos');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarCliente(idIntegrador) {
    try {
      this.carregandoService.mostra('buscarCliente');

      this.cliente = await this.clienteService.consultarPorIdCliente(idIntegrador, true).toPromise();

      this.carregandoService.esconde('buscarCliente');
    } catch (erro) {
      this.carregandoService.esconde('buscarCliente');
      this.notificacaoService.erro(erro);
    }
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarPedidos();
    this.buscarTotaisPedidos();
    this.paginator.firstPage();
  }

  exportar() {
    this.carregandoService.mostra('exportarRepasse');

    localStorage.setItem('filtroRepasse', JSON.stringify(this.filtroPedido));

    let etapas = undefined;

    this.pedidoService.exportarRepasse(this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc',
      this.filtroPedido.dtInicio && typeof this.filtroPedido.dtInicio !== 'string' ? this.filtroPedido.dtInicio.toISOString() : this.filtroPedido.dtInicio,
      this.filtroPedido.dtFim && typeof this.filtroPedido.dtFim !== 'string' ? this.filtroPedido.dtFim.toISOString() : this.filtroPedido.dtFim,
      this.filtroPedido.nomeCliente, this.filtroPedido.idCupom, this.filtroPedido.status,
      this.filtroPedido.funcionario === 0 ? undefined : this.filtroPedido.funcionario === -1 ? this.usuarioLogado.id : this.filtroPedido.funcionario,
      etapas, false, false, this.filtroPedido.integrador ? this.filtroPedido.integrador : null, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true, this.filtroPedido.orcStatus, null, null, null, null, this.filtroPedido.codErp, null, null, false, false, true, false).subscribe(arq => {

        this.utilitarioService.saveBlob(arq, 'Repasse.xlsx');

        this.carregando = false;
        this.carregandoService.esconde('exportarRepasse');
      }, (erro) => {
        this.carregandoService.esconde('exportarRepasse');
        this.notificacaoService.erro(erro);
      });
  }

  buscarPedidos() {
    this.carregandoService.mostra('buscaPedidos');

    localStorage.setItem('filtroRepasse', JSON.stringify(this.filtroPedido));

    let etapas = undefined;

    this.pedidoService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc',
      this.filtroPedido.dtInicio && typeof this.filtroPedido.dtInicio !== 'string' ? this.filtroPedido.dtInicio.toISOString() : this.filtroPedido.dtInicio,
      this.filtroPedido.dtFim && typeof this.filtroPedido.dtFim !== 'string' ? this.filtroPedido.dtFim.toISOString() : this.filtroPedido.dtFim,
      this.filtroPedido.nomeCliente, this.filtroPedido.idCupom, this.filtroPedido.status,
      this.filtroPedido.funcionario === 0 ? undefined : this.filtroPedido.funcionario === -1 ? this.usuarioLogado.id : this.filtroPedido.funcionario,
      etapas, false, false, this.filtroPedido.integrador ? this.filtroPedido.integrador : null, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true, this.filtroPedido.orcStatus, null, null, null, null, this.filtroPedido.codErp, null, null, false, false, true, false).subscribe(dados => {
        this.pedidosFiltrados = dados.itens;

        this.carregando = false;
        this.carregandoService.esconde('buscaPedidos');
      }, (erro) => {
        this.carregandoService.esconde('buscaPedidos');
        this.notificacaoService.erro(erro);
      });
  }

  buscarTotaisPedidos() {
    localStorage.setItem('filtroRepasse', JSON.stringify(this.filtroPedido));
    this.buscouTotalPag = false;

    let etapas = undefined;

    this.pedidoService.consultarTotalPaginacao(
      this.filtroPedido.dtInicio && typeof this.filtroPedido.dtInicio !== 'string' ? this.filtroPedido.dtInicio.toISOString() : this.filtroPedido.dtInicio,
      this.filtroPedido.dtFim && typeof this.filtroPedido.dtFim !== 'string' ? this.filtroPedido.dtFim.toISOString() : this.filtroPedido.dtFim,
      this.filtroPedido.nomeCliente, this.filtroPedido.idCupom, this.filtroPedido.status,
      this.filtroPedido.funcionario === 0 ? undefined : this.filtroPedido.funcionario === -1 ? this.usuarioLogado.id : this.filtroPedido.funcionario,
      etapas, false, false, this.filtroPedido.integrador ? this.filtroPedido.integrador : null, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true, this.filtroPedido.orcStatus, null, null, null, null, this.filtroPedido.codErp, null, null, false, false, true, false).subscribe(dados => {
        this.paginacao.total = dados.total;
        this.buscouTotalPag = true;

        this.carregando = false;
        this.carregandoService.esconde('buscaPedidos');
      }, (erro) => {
        this.buscouTotalPag = true;
        this.carregandoService.esconde('buscaPedidos');
        this.notificacaoService.erro(erro);
      });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarPedidos();
    this.buscarTotaisPedidos();
  }

  pesquisarPedido() {
    const filtroTemp = Object.assign({}, this.filtroPedido);

    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(FiltroPedidoComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { filtro: filtroTemp, tipo: 1, repasse: true, origem: OrigemFiltroPedido.Repasse },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: FiltroPedido) => {
      if (result) {
        this.filtroPedido = result;
        this.buscarPedidos();
        this.buscarTotaisPedidos();
      }
    });
  }

  ngOnDestroy(): void { }

  restaurarFiltros() {
    this.filtroPedido = {
      dtFim: undefined, dtInicio: undefined, funcionario: undefined, idCupom: '', nomeCliente: '', status: undefined, etapas: [],
      integrador: undefined, orcStatus: undefined, codErp: '', pesquisaPorTimes: false
    };
    this.buscarPedidos();
    this.buscarTotaisPedidos();
  }

  imprimirPedido(idPedido) {
    this.carregandoService.mostra('imprimirPedido');

    this.relatorioService.pedido(idPedido).subscribe(resp => {
      this.notificacaoService.sucesso('Documento gerado com sucesso!!!');
      this.utilitarioService.openBlob(resp);

      this.carregandoService.esconde('imprimirPedido');
    }, (erro) => {
      const reader = new FileReader();

      // This fires after the blob has been read/loaded.
      reader.addEventListener('loadend', (e) => {
        const text = e.srcElement['result'];
        this.carregandoService.esconde('imprimirPedido');
        this.notificacaoService.erro(text);
      });

      // Start reading the blob as text.
      reader.readAsText(erro.error);
    });
  }

  anexos(pedido: Pedido) {
    if (this.integrador) {
      this.carregandoService.mostra('buscaPedidoAnexos');

      this.pedidoAnexoService.possuiAnexoDeIntegrador(pedido.idCupom).subscribe(dados => {
        if (!dados.valor) {
          this.visualizarTermo(pedido);
        } else {
          this.exibirAnexos(pedido);
        }
        this.carregandoService.esconde('buscaPedidoAnexos');
      }, (erro) => {
        this.carregandoService.esconde('buscaPedidoAnexos');
        this.notificacaoService.erro(erro);
      });
    } else {
      this.exibirAnexos(pedido);
    }
  }

  exibirAnexos(pedido: Pedido) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(PedidoAnexoComponent, {
      width: this.integrador && largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        idPedido: pedido.idCupom,
        podeEditar: true,
        origem: 1
      },
      panelClass: 'modal-card'
    });
  }

  alterarStatusOrcamento(pedido: PedidoLista) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(SelecionarStatusOrcamentoModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: {
        idCupom: pedido.idCupom,
        idStatus: pedido.orcStatus,
        tipo: 1
      },
      panelClass: 'modal-card'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarPedidos();
        this.buscarTotaisPedidos();
      }
    });
  }

  visualizarTermo(pedido: Pedido) {
    this.carregandoService.mostra('termosDeUso');

    this.pedidoService.baixarTermoRepasse().subscribe(resp => {
      this.carregandoService.esconde('termosDeUso');

      let link = URL.createObjectURL(resp);

      const dialogRef = this.dialog.open(VisualizadorPdfComponent, {
        width: ($('body').width()).toString() + 'px',
        data: {
          arquivo: resp,
          nomeArquivo: 'TermosDeUsoRepasse.pdf',
          aceite: true
        },
        panelClass: 'modal-card'
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) { this.exibirAnexos(pedido); }
      });
    }, (erro) => {
      const reader = new FileReader();

      // This fires after the blob has been read/loaded.
      reader.addEventListener('loadend', (e) => {
        const text = e.srcElement['result'];
        this.carregandoService.esconde('termosDeUso');
        this.notificacaoService.erro(text);
      });

      // Start reading the blob as text.
      reader.readAsText(erro.error);
    });

    return false;
  }
}
